import { getCountry as m } from "./get-country.mjs";
import { parseCountry as D } from "./parse-country.mjs";
import { removeNonDigits as M } from "../common/remove-non-digits.mjs";
const v = ({
  phone: n,
  countries: c,
  currentCountryIso2: f,
  defaultCountry: y
}) => {
  var h;
  const u = {
    country: void 0,
    fullDialCodeMatch: !1,
    areaCodeMatch: void 0
  };
  if (!n)
    return u;
  const r = M(n);
  if (!r)
    return u;
  let e = u;
  const C = ({
    country: o,
    fullDialCodeMatch: a,
    areaCodeMatch: t
  }) => {
    var d, s;
    const i = o.dialCode === ((d = e.country) == null ? void 0 : d.dialCode), l = (o.priority ?? 0) < (((s = e.country) == null ? void 0 : s.priority) ?? 0);
    (!i || l) && (e = { country: o, fullDialCodeMatch: a, areaCodeMatch: t });
  };
  for (const o of c) {
    const a = D(o), { dialCode: t, areaCodes: i } = a;
    if (r.startsWith(t)) {
      const l = e.country ? Number(t) >= Number(e.country.dialCode) : !0;
      if (i) {
        const d = r.substring(t.length);
        for (const s of i)
          if (d.startsWith(s))
            return {
              country: a,
              fullDialCodeMatch: !0,
              areaCodeMatch: !0
            };
      }
      (l || t === r || !e.fullDialCodeMatch) && C({
        country: a,
        fullDialCodeMatch: !0,
        areaCodeMatch: i ? !i : void 0
      });
    }
    e.fullDialCodeMatch || r.length < t.length && t.startsWith(r) && (!e.country || Number(t) <= Number(e.country.dialCode)) && C({ country: a, fullDialCodeMatch: !1 });
  }
  if (f) {
    const o = m({
      value: f,
      field: "iso2",
      countries: c,
      defaultCountry: y
    });
    !!e && !!o && // different countries with same dial code
    ((h = e.country) == null ? void 0 : h.dialCode) === o.dialCode && e.country !== o && // full dial code match (without area code)
    e.fullDialCodeMatch && !e.areaCodeMatch && (e = {
      country: o,
      areaCodeMatch: o != null && o.areaCodes ? !1 : void 0,
      fullDialCodeMatch: !0
    });
  }
  return e;
};
export {
  v as guessCountryByPartialNumber
};
